import { CreditLineProvider, Omit, Pick } from '@40seas/entities/common';
import { BaseEntityFieldsArray } from '@40seas/models';
import { CreditLine, SupplierCreditLine } from './credit-line.entity';

export class CreateCreditLineDto extends Omit(CreditLine, [...BaseEntityFieldsArray, 'isActive'], ['isActive']) {
    isActive?: boolean;
}

export class CreateSupplierCreditLineDto extends Omit(SupplierCreditLine, [...BaseEntityFieldsArray, 'isActive'], ['isActive']) {
    isActive?: boolean;
}
